module.exports = __webpack_public_path__ + "static/media/up_arrow.f72fea92.svg";